export default "__VITE_ASSET__BmbpxS5J__"